import { useSelector } from 'react-redux';

//Simple wrapper component for cost fields.
export default ({ children, isHaggle }) => {
  const costPermission = useSelector(store => store.app?.fullUserDetails?.companyUser?.costViewPermission);

  if (costPermission === 'ALL' || (isHaggle && costPermission === 'HAGGLE')) {
    return children;
  }
  return null;
};
